import { useState } from "react";
import { useTranslation } from "react-i18next";
import { resendWorkSecurityDocument } from "services/work-security.service";

/**
 * «Persiųsti el. laišką» for one signer of a role document. The server decides which email goes
 * out: a reminder for a signer whose request is pending, a fresh invitation for one who declined
 * or has no request yet.
 */
export default function SignerResendButton({
  companyId,
  roleId,
  documentId,
  userId,
  onSent,
}: {
  companyId: string;
  roleId: string;
  documentId: string;
  userId: string;
  onSent: () => void;
}) {
  const { t } = useTranslation();
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);

  const send = async () => {
    setIsSending(true);
    setHasFailed(false);
    try {
      await resendWorkSecurityDocument(companyId, roleId, documentId, userId);
      setIsSent(true);
      onSent();
    } catch {
      setHasFailed(true);
    } finally {
      setIsSending(false);
    }
  };

  if (isSent) return <span className="text-xs font-medium text-green-600">{t("reminder_sent")}</span>;

  return (
    <span className="inline-flex items-center gap-2">
      <button
        type="button"
        className="flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50 max-md:min-h-11 max-md:px-3 max-md:text-sm"
        onClick={send}
        disabled={isSending}
      >
        {isSending && (
          <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />
        )}
        {t("resend")}
      </button>
      {hasFailed && <span className="text-xs text-red-600">{t("files_reminder_failed")}</span>}
    </span>
  );
}
